import { Box } from "@mui/material";
import Alert from "@mui/material/Alert";
import FilterableSkuList, {
  SkuListColumn,
  SkuListFilter,
} from "components/FilterableSkuList";
import Loader from "components/Loader";
import RedirectBackButton from "components/RedirectBackButton";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQuery } from "react-query";
import { Navigate, useParams } from "react-router-dom";
import { ResponseOfQualification } from "services/KnowfullyAdminClient";
import contextStore from "stores/contextStore";

const qualificationSkuFilters = [
  SkuListFilter.Search,
  SkuListFilter.Dates,
  SkuListFilter.SkuFormat,
  SkuListFilter.SkuAvailability,
  SkuListFilter.SkuStatus,
  SkuListFilter.ApprovalStatus,
];

const QualificationSkus = () => {
  const { formatMessage: t } = useIntl();
  const { id } = useParams<{ id: string }>();
  const { qualificationService, qualificationDetailsUrl } = useGlobalContext();
  const { organizationId } = contextStore.useState();

  const qualificationResult = useQuery<ResponseOfQualification>(
    ["qualification", id],
    () => qualificationService.getQualificationById(id!),
    {
      enabled: !!id,
    },
  );

  const qualification = qualificationResult.data?.data;
  useTitle(
    t(
      { id: "associatedSkusTitle" },
      { name: qualification?.value || t({ id: "accreditationBodyLabel" }) },
    ),
  );

  if (!id) {
    return <Navigate to={qualificationDetailsUrl(id)} replace />;
  }
  if (qualificationResult.isLoading) {
    return <Loader />;
  }
  if (qualificationResult.isError) {
    return (
      <Box mt={4}>
        <Alert severity="error">
          <T id="accreditationBodyLoadError" />
        </Alert>
      </Box>
    );
  }

  return (
    <>
      <RedirectBackButton
        redirectRoute={qualificationDetailsUrl(id)}
        labelKey="backToAccreditationBody"
      />
      <h1>
        <u>
          <T id="associatedSkus" />
        </u>
        : {qualification?.value}
      </h1>
      <FilterableSkuList
        organizationId={organizationId}
        lazyTableTitle="associatedSkus"
        preSelectedQualificationIds={[id]}
        columns={[
          SkuListColumn.Sku,
          SkuListColumn.Title,
          SkuListColumn.SkuFormat,
          SkuListColumn.SkuAvailability,
          SkuListColumn.Status,
        ]}
        filters={qualificationSkuFilters}
      />
    </>
  );
};

export default QualificationSkus;
